export default __webpack_public_path__ + "static/media/54.487ca1d3.gif";